import React from 'react';
import CustomSlider from '../UI/CustomSlider';
import LiteToggleSwitch from './LiteToggleSwitch';

/**
 * ExpandedControls — opacity, volume, pause-at-last-frame / loop toggles.
 * Shown in the "Show all properties" expanded view for each layer.
 */
const ExpandedControls = ({ layer, onControlChange, onSliderStart, onSliderEnd }) => {
  if (!layer) return null;
  const { controls } = layer;

  return (
    <div className="space-y-3">
      {/* Opacity */}
      <CustomSlider
        label="Opacity"
        value={(controls.opacity !== undefined ? controls.opacity : 1) * 100}
        onChange={(val) => onControlChange(layer, 'alpha', val / 100)}
        min={0}
        max={100}
        valueFormatter={(v) => `${Math.round(v)}%`}
        onSliderStart={onSliderStart}
        onSliderEnd={onSliderEnd}
      />

      {/* Media controls (volume, playback mode) */}
      {controls.hasMediaControls && (
        <>
          <CustomSlider
            label="Volume"
            value={controls.muted ? 0 : controls.volume * 100}
            onChange={(val) => {
              onControlChange(layer, 'volume', val / 100);
              if (val > 0 && controls.muted) onControlChange(layer, 'muted', false);
            }}
            min={0}
            max={100}
            valueFormatter={(v) => `${Math.round(v)}%`}
            onSliderStart={onSliderStart}
            onSliderEnd={onSliderEnd}
          />

          <div className="flex items-center justify-between">
            <span className="text-xs text-white">Pause at last frame</span>
            <LiteToggleSwitch
              checked={controls.playbackMode === 'pause'}
              onChange={(checked) =>
                onControlChange(layer, 'playbackMode', checked ? 'pause' : 'loop')
              }
            />
          </div>

          <div className="flex items-center justify-between">
            <span className="text-xs text-white">Loop</span>
            <LiteToggleSwitch
              checked={controls.playbackMode === 'loop' || !controls.playbackMode}
              onChange={(checked) =>
                onControlChange(layer, 'playbackMode', checked ? 'loop' : 'pause')
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ExpandedControls;
